import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import useDebounce from 'modules/common/components/UseDebounce';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import DistrictContent from './DistrictContent';
import DistrictModal from '../components/DistrictModal';

const form = {
  keyword: '',
};

function DistrictContainer({
  match,
  history,
  getDistrictList,
  districtList,
  isLoading,
  removeDistrict,
  districtListPager,
  getSingleDistrict,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <DistrictModal type="NEW" />,
      title: 'Add District',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <DistrictModal type="EDIT" updateList={data.attributes} districtId={data.id} />,
      title: 'Update District',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this District?',
      () => {
        removeDistrict(data.id, () => {
          getDistrictList();
          const id = _.get(districtList, '0.id');
          if (id !== data.id) {
            history.push(`${id}`);
            getSingleDistrict(id);
          } else {
            window.location.pathname = '/rpt/settings/property-locations/districts';
            history.replace({
              pathname: '/rpt/settings/property-locations/districts',
            });
          }
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getDistrictList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc'
  };
  useEffect(() => {
    if (debouncedSearchTerm) {
      getDistrictList({ q: formData.keyword });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:districtId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Districts"
            getData={getDistrictList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:districtId?`}
            listName="Districts"
            label="Districts"
            renderItem={(item) => (
              <div className="p-3">{_.get(item, 'attributes.code')}</div>
            )}
            isLoading={isLoading}
            selected={params.districtId}
            data={districtList}
            dataPager={districtListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:districtId?`}
                    render={() => (
                      <DistrictContent
                        handleAddModal={handleAddModal}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:districtId?`}
                  render={() =>
                    !params.districtId && districtList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(districtList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

DistrictContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getDistrictList: PropTypes.instanceOf(Function).isRequired,
  districtList: PropTypes.instanceOf(Array).isRequired,
  districtListPager: PropTypes.instanceOf(Object).isRequired,
  removeDistrict: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  getSingleDistrict: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  districtList: _.get(api, `${c.GET_DISTRICTS}.list`) || [],
  districtListPager: _.get(api, `${c.GET_DISTRICTS}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_DISTRICTS) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(DistrictContainer);
